<script>
export default {
  name: 'AdminDataTable',
  props: {
    columns: {
      type: Array,
      required: true,
    },
    items: {
      type: Array,
      default: () => [],
    },
    rowKey: {
      type: String,
      default: 'id',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    emptyText: {
      type: String,
      default: '데이터가 없습니다.',
    },
    hover: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    headers() {
      return this.columns.map((column) => ({
        key: column.key,
        title: column.title,
        sortable: Boolean(column.sortable),
        align: column.align || 'start',
        width: column.width,
        headerProps: { class: column.headerClass || '' },
        cellProps: { class: column.cellClass || '' },
      }))
    },
  },
  methods: {
    onRowClick(_event, payload) {
      this.$emit('row-click', payload?.item, payload?.index)
    },
    onSortChange(sortBy) {
      this.$emit('sort-change', sortBy)
    },
    resolveCellValue(slotProps, key) {
      if (slotProps?.item && Object.prototype.hasOwnProperty.call(slotProps.item, key)) {
        return slotProps.item[key]
      }
      if (slotProps?.item?.raw && Object.prototype.hasOwnProperty.call(slotProps.item.raw, key)) {
        return slotProps.item.raw[key]
      }
      return ''
    },
  },
}
</script>

<template>
  <div class="admin-data-table admin-page-card">
    <v-data-table
      :headers="headers"
      :items="items"
      :item-value="rowKey"
      :loading="loading"
      :hover="hover"
      hide-default-footer
      class="elevation-0"
      @click:row="onRowClick"
      @update:sort-by="onSortChange"
    >
      <template v-for="column in columns" :key="column.key" #[`item.${column.key}`]="slotProps">
        <slot :name="`cell-${column.key}`" v-bind="slotProps">
          {{ resolveCellValue(slotProps, column.key) }}
        </slot>
      </template>

      <template #loading>
        <slot name="loading">
          <div class="pa-6 text-medium-emphasis">로딩 중...</div>
        </slot>
      </template>

      <template #no-data>
        <slot name="empty">
          <div class="pa-6 text-medium-emphasis">{{ emptyText }}</div>
        </slot>
      </template>
    </v-data-table>
  </div>
</template>

<style scoped>
.admin-data-table {
  overflow: hidden;
}
</style>
